<template>
  <div class="container">
    <div class="uploadBox">
      <el-form
        ref="companyform"
        :model="form"
        :rules="rules"
        size="small"
        v-enterToNext="true"
      >
        <el-form-item label="公章上传(透明底）" prop="license">
          <el-upload
            :class="{ 'hide-upload': isHideUpload }"
            action=""
            accept=".jpg,.png"
            :limit="1"
            list-type="picture-card"
            :file-list="form.license"
            :before-remove="removeLicense"
            :http-request="uploadLicense"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过10M
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          type="primary"
          @click="onSubmit('companyform')"
          v-if="verifyPermission('Add')"
          >提 交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { verifyPermissionMinix } from "@/utils/mixin";

export default {
  //import引入组件才能使用
  components: {},
  props: {},
  mixins: [verifyPermissionMinix],
  data() {
    return {
      rules: {
        license: [{ required: true, message: "请上传公章", trigger: "blur" }],
      },
      form: {
        license: [],
      },
      CompanyDetail: {},
    };
  },
  // 计算属性
  computed: {
    isHideUpload: function () {
      return this.form.license.length == 1;
    },
  },
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted() {
    this.CompanyDetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    if (this.CompanyDetail.commonSeal) {
      this.form.license.push({
        url: this.CompanyDetail.commonSeal,
      });
    }
  },
  // 方法集合
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");

          return;
        }
        let sendData = {
          id: this.CompanyDetail.id,
          fieldName: "commonSeal",
          fieldValue: this.form.license ? this.form.license[0].url : "",
        };
        this.$api.user.OneselfFieldChange(sendData).then((res) => {
          if (!res.error) {
            this.$message.success("上传成功");
            this.getCompanyDetail();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    getCompanyDetail() {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.detail = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
          console.log(res);
        }
      });
    },
    removeLicense() {
      this.form.license.splice(0, 1);
      this.isHideUpload = false;
      console.log(this.form);
    },
    uploadLicense(fileObj) {
      this.submitLoading = true;
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0 && res.data[0]) {
            this.isHideUpload = true;
            this.form.license.push({ name: "", url: res.data[0] });
            this.$refs.companyform.validateField(["license"]);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form.license = [];
          }
        });
    },
  },
};
</script>
<style lang="less">
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
<style scoped lang='less'>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  .uploadBox {
    padding: 20px;
    width: 400px;
    height: 300px;
    margin-top: 100px;
    background-color: #fff;
  }
}
</style>